module.exports = __webpack_public_path__ + "img/H3C.87ef5812.png";